import type { NavigationGuardWithThis } from 'vue-router';
import useAuthStore from '@/stores/authStore';
import useGlobalStore from '@/stores/globalStore';
import { loadLocaleMessages } from '@/plugins/i18n';

let isFirstLoad = true;

export default <NavigationGuardWithThis<undefined>>(async (to, _from, next) => {
  const authStore = useAuthStore();
  const globalStore = useGlobalStore();
  const promises: Promise<void>[] = [];

  if (isFirstLoad) {
    isFirstLoad = false;
    await Promise.all([
      authStore.getMe(),
      loadLocaleMessages(),
      globalStore.fetchCountries(),
    ]);
  }

  if (authStore.isAuth) {
    if (authStore.isDashboard && to.path.startsWith('/dashboard')) {
      promises.push(globalStore.fetchDashboardAvailableYears());
    } else {
      promises.push(globalStore.fetchCompanyAvailableYears());
    }
  }

  await Promise.all(promises);

  return next();
});
